export const createMeta = vm => ({
  title: vm.$t('list.seo.title', { storeName: vm.storeInfo?.name }),
  meta: {
    pageTitle: { name: 'Page Title', content: vm.$t('list.seo.pageTitle', { storeName: vm.storeInfo?.name }) },
    description: { name: 'description', content: `Daftar menu dan harga lengkap di ${vm.storeInfo?.name}. Pesan untuk pick up atau delivery lewat Desty Menu.` },

    ogType: { property: 'og:type', content: 'website' },
    ogSite_name: { property: 'og:site_name', content: 'Desty Menu' },
    ogLocale: { property: 'og:locale', content: 'id-ID' },
    ogImage: { property: 'og:image', content: `${vm.storeInfo?.logo || 'https://static.bakmigm.co.id/snk/share/desty-icon-share.png'}` },
    ogImageSecure_url: { property: 'og:image:secure_url', content: `${vm.storeInfo?.logo || 'https://static.bakmigm.co.id/snk/share/desty-icon-share.png'}` },
    ogImageWidth: { property: 'og:image:width', content: '600' },
    ogImageHeight: { property: 'og:image:height', content: '600' },
    ogImageType: { property: 'og:image:type', content: 'image/jpg' },
    twitterCard: { property: 'twitter:card', content: 'summary_large_image' },
    twitterImage: { property: 'twitter:image', content: `${vm.storeInfo?.logo || 'https://static.bakmigm.co.id/snk/share/desty-icon-share.png'}` },
    twitterDomain: { property: 'twitter:domain', content: 'Desty Menu' },

    ogUrl: { property: 'og:url', content: `https://order.bakmigm.co.id/${vm.$route.path}` },
    ogTitle: { property: 'og:title', content: `${vm.storeInfo?.name} - Daftar menu lengkap, harga, dan pemesanan di Desty Menu` },
    ogDescription: { property: 'og:description', content: `Daftar menu dan harga lengkap di ${vm.storeInfo?.name}. Pesan untuk pick up atau delivery lewat Desty Menu.` },

    twitterUrl: { property: 'twitter:url', content: `https://order.bakmigm.co.id/${vm.storeUrl}` },
    twitterTitle: { property: 'twitter:title', content: `${vm.storeInfo?.name} - Daftar menu lengkap, harga, dan pemesanan di Desty Menu` },
    twitterDescription: { property: 'twitter:description', content: `Daftar menu dan harga lengkap di ${vm.storeInfo?.name}. Pesan untuk pick up atau delivery lewat Desty Menu.` },
  },
})
